<script setup>
import MyRoutes from "../../router/index";
import feather from "feather-icons";
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";

const auth = useAuthStore();

function icon_exists(icon) {
  return feather.icons[icon] !== undefined;
}

function visible(route) {
  if (route.aliasOf) return false;
  if (route.meta?.hidden) return false;
  if (route.meta?.perm && !auth.can(route.meta.perm)) return false;
  if ((route.meta?.requiresAuth || route.meta?.adminOnly) && !auth.isLoggedIn) return false;
  return true;
}

const routes = computed(() => MyRoutes.getRoutes());
</script>
<template>
  <nav>
    <div class="btn-group flex items-center">
      <div v-for="route in routes" :key="route.path">
        <RouterLink
          v-if="visible(route)"
          class="btn btn-ghost"
          :class="{ 'btn-active': route.path === $route.path }"
          :to="route.path"
          ><div>
            <div
              v-if="route.meta.icon && icon_exists(route.meta.icon)"
              class="icon"
            >
              <v-icon :type="route.meta.icon"></v-icon>
            </div>
            <div v-else>[x]</div>
            {{ route.meta.navTitle || route.meta.title || route.name }}
          </div>
        </RouterLink>
      </div>
    </div>
  </nav>
</template>

<style>
.nav .btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav .btn .icon {
  margin-right: 0.5rem;
}

.nav .btn-active {
  font-weight: bold;
}
</style>
